import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import Alert from '../components/UI/Alert';
import Layout from '../components/Claims/AddClaim/AddClaim';
// import style from '../assets/styles/ToasterStyle';

class AddClaim extends Component {
  files = {
    physician_notes: false,
    hospital_receipts: false,
    discharge_report: false,
    proof_of_payment: false,
    lab_tests: false,
  };

  constructor() {
    super();
    this.state = {
      active: '1',
      defaultValues: {},
      bankSelected: true,
      isMandatoryFiles: false,
      mandatoryFilesUploaded: this.files,
      btnClick: false,
      filesSelected: false,
      bankDeleteLoading: false,
    };
  }

  async componentDidMount() {
    this.getBankList();
    this.getCountryList();
    this.getCurrencyList();
  }

  /**
   * get bank list
   */
  getBankList = async () => {
    const { getBankList } = this.props;
    try {
      const { success, data } = await getBankList();
      if (success) {
        this.setState((prev) => ({ ...prev, bankList: data }));
      }
      return false;
    } catch (error) {
      console.log(error);
    }
    return [];
  };

  /**
   * get currency list
   */
  getCurrencyList = async () => {
    const { getCurrencyList } = this.props;
    try {
      const { success, data } = await getCurrencyList();
      if (success) {
        this.setState((prev) => ({ ...prev, currencyList: data }));
      }
      return success;
    } catch (error) {
      console.log(error);
    }
    return [];
  };

  /**
   * get currency list
   */
  getCountryList = async () => {
    const { getCountryList } = this.props;
    try {
      const { success, data } = await getCountryList();
      if (success) {
        this.setState((prev) => ({ ...prev, countryList: data }));
      }
      return success;
    } catch (error) {
      console.log(error);
    }
    return [];
  };

  /**
   * get currency list
   */
  addBankAccount = async (data) => {
    const { addBankAccount, refresh, currentPolicy } = this.props;
    this.setState((pre) => ({ ...pre, loading: true }));
    try {
      const { success, message } = await addBankAccount(data);
      if (success) {
        toast.custom(<Alert message="Bank Account Added" />);
        refresh(currentPolicy);
      } else {
        toast.custom(<Alert message={message} />);
      }
      this.setState((pre) => ({ ...pre, loading: false }));
      return success;
    } catch (error) {
      console.log(error);
    }
    this.setState((pre) => ({ ...pre, loading: false }));
    return [];
  };

  transform = (rawData) => ({
    policy_id: rawData?.policy_id,
    claim_date: rawData?.claim_date || '',
    claim_type: rawData?.claim_type || '',
    payable: rawData?.payable_to || '',
    dependent_id: rawData?.patient !== '0' ? rawData?.patient : '',
    treatment_date: rawData?.claim_date || '',
    additional_info: '',
    bank_name: rawData?.bank_name || '',
    iban_no: rawData?.iban_no || '',
    swift: rawData?.swift || '',
    bank_address: rawData?.ifsc_or_aba || '',
    bank_id: rawData?.bank_id || '',
    claimed_amount: rawData?.claimed_amount || '',
    payment_method: rawData?.payment_method || '',
    scheduled_to_pay: rawData?.claim_date || '',
    account_number: rawData?.account_no || '',
    status: rawData?.status,
    country_id: rawData?.country_id || null,
    currency_id: rawData?.currency_id || null,
    email: rawData?.email || null,
    mobile_number: rawData?.mobile_number || null,
    submission_type: 'member_portal',
  });

  // Submit new claim : from step 2
  onConfirm = async (data, status = 'draft') => {
    const { currentPolicy, addClaim, history } = this.props;
    const { newClaim } = this.state;

    // let isMandatory = null;
    // if (status !== 'draft') {
    //   this.setState({ btnClick: true });
    //   Object.keys(this.files).forEach((item) => {
    //     if (Object.keys(newClaim[item] || {})?.length) {
    //       this.files[item] = true;
    //     } else {
    //       this.files[item] = false;
    //     }
    //   });

    //   isMandatory = true;

    //   Object.keys(this.files).forEach((item) => {
    //     if (!this.files[item]) {
    //       isMandatory = false;
    //     }
    //   });
    // }

    // if (isMandatory || status === 'draft') {
    const payload = {
      ...newClaim,
      ...this.transform({ ...newClaim, ...data, status, policy_id: currentPolicy?.id }),
    };

    const selectedBank = currentPolicy?.member_details?.bank_accounts?.filter(
      (bank) => bank?.id?.toString() === payload?.bank_id,
    )[0];
    // Checks if the selected bank contains the iban number which
    if (['234', '118', '179', '18'].includes(selectedBank?.bank_country) && !selectedBank?.iban_no) {
      toast.custom(
        <Alert message="Please choose a bank account with an IBAN number. IBAN is mandatory for UAE, Bahrain, Qatar and Kuwait." />,
        {
          duration: 5000,
        },
      );
      return;
    }
    if (selectedBank?.bank_country === '166' && (!selectedBank?.iban_no || !selectedBank?.account_no)) {
      toast.custom(
        <Alert message="Please choose a bank account with both IBAN and Account Number. Both are mandatory for Oman." />,
        {
          duration: 5000,
        },
      );
      return;
    }

    const formData = new FormData();
    let fileSelected = 0;

    Object.keys(payload).forEach((key) => {
      if (key === 'claimed_amount') {
        payload[key] = payload[key].replaceAll(',', '');
      }
      if (typeof payload[key] === 'object' && payload[key]) {
        Object.keys(payload[key]).forEach((subKey) => {
          formData.append(`${key}[${subKey}]`, payload[key][subKey]);
          fileSelected += 1;
        });
        return;
      }
      formData.append(key, payload[key]);
    });

    if (fileSelected !== 0 || status === 'draft') {
      this.setState((pre) => ({ ...pre, loading: true }));
      // POST REQUEST
      const resData = await addClaim(formData);
      if (resData?.success) {
        if (status === 'draft') {
          toast.custom(
            <Alert message={`Claim - Drafted successfully. Tracking number is ${resData?.reference_number}`} />,
          );
          history.push('/claims');
        } else {
          this.setState((pre) => ({
            ...pre,
            loading: false,
            success: true,
            mems_success: resData?.mems_success,
            ucrn: resData?.reference_number,
            draft: status === 'draft',
            submissionType: resData?.data?.submission_type,
          }));
        }
      } else {
        this.setState((pre) => ({ ...pre, loading: false, success: false, message: resData?.message }));
        toast.custom(<Alert message={data?.message} />);
      }
    } else {
      toast.custom(<Alert message="Please choose at least 1 Document" />);
    }
    // } else {
    //   console.log('Mandatory files');
    // }
  };

  // The continue button in step 1
  // this function only saves the current state in client
  onContinue = async (data, validation) => {
    if (validation) {
      if (data?.bank_id) {
        this.setState((pre) => ({
          ...pre,
          newClaim: { ...pre?.newClaim, ...data, payment_method: '0' },
          active: '2',
          firstStepPassed: true,
          bankSelected: true,
        }));
        console.log(this.state);
        console.log('CONTINUE');
      } else {
        this.setState((pre) => ({ ...pre, newClaim: { ...pre?.newClaim, ...data }, bankSelected: false }));
        console.log('STOP');
      }
    } else {
      this.setState((pre) => ({ ...pre, newClaim: { ...pre?.newClaim, ...data }, bankSelected: false }));
    }
  };

  setActive = (tab) => {
    const { firstStepPassed } = this.state;
    if (tab === '2' && firstStepPassed) {
      this.setState((pre) => ({ ...pre, active: tab }));
    } else if (tab === '1') {
      this.setState((pre) => ({ ...pre, active: tab }));
    }
  };

  onFileSelected = (fileList, type) => {
    if (fileList.length) {
      this.filesSelected = true;
      this.setState((pre) => ({
        ...pre,
        newClaim: {
          ...pre.newClaim,
          [type]: fileList,
          filesSelected: !!fileList.length, // Count of files selected
        },
        // mandatoryFilesUploaded: this.files,
      }));
    } else {
      // For deleting files
      this.setState((pre) => ({
        ...pre,
        newClaim: { ...pre.newClaim, [type]: {} },
        // mandatoryFilesUploaded: this.files,
      }));
    }
  };

  deleteBank = async (bankId) => {
    const { deleteBank, refresh, currentPolicy } = this.props;
    console.log(bankId);
    this.setState((val) => ({ ...val, bankDeleteLoading: true }));
    const { success, message } = await deleteBank(bankId);
    if (success) {
      await refresh(currentPolicy);
      toast.custom(<Alert message="Bank Account Deleted" />);
    } else {
      toast.custom(<Alert message={message} />);
    }
    this.setState((val) => ({ ...val, bankDeleteLoading: false }));
  };

  /**
   * Render
   */
  render = () => {
    const {
      defaultValues,
      bankList,
      countryList,
      currencyList,
      active,
      loading,
      bankSelected,
      mandatoryFilesUploaded,
      btnClick,
      success,
      mems_success,
      ucrn,
      draft,
      message,
      bankDeleteLoading,
      submissionType,
    } = this.state;
    const { currentPolicy } = this.props;
    return (
      <Layout
        loading={loading}
        data={defaultValues}
        onConfirm={this.onConfirm}
        onContinue={this.onContinue}
        bankList={bankList}
        currencyList={currencyList}
        countryList={countryList}
        policyData={currentPolicy}
        active={active}
        setActive={this.setActive}
        addBankAccount={this.addBankAccount}
        onFileSelected={this.onFileSelected}
        deleteBank={this.deleteBank}
        bankSelected={bankSelected}
        btnClick={btnClick}
        success={success}
        memsSuccess={mems_success}
        ucrn={ucrn}
        draft={draft}
        message={message}
        mandatoryFilesUploaded={mandatoryFilesUploaded}
        bankDeleteLoading={bankDeleteLoading}
        submissionType={submissionType}
      />
    );
  };
}

AddClaim.propTypes = {
  userInput: PropTypes.shape({}).isRequired,
  currentPolicy: PropTypes.shape({
    id: PropTypes.number.isRequired,
    member_details: PropTypes.shape({
      bank_accounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.shape({}),
  }).isRequired,
  getBankList: PropTypes.func.isRequired,
  getCurrencyList: PropTypes.func.isRequired,
  getCountryList: PropTypes.func.isRequired,
  addBankAccount: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  addClaim: PropTypes.func.isRequired,
  deleteBank: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userInput: state.articles.userInput || {},
  currentPolicy: state.policy.currentPolicy || {},
});

const mapDispatchToProps = (dispatch) => ({
  getBankList: dispatch.claim.getBankList,
  getCurrencyList: dispatch.claim.getCurrencyList,
  getCountryList: dispatch.claim.getCountryList,
  addBankAccount: dispatch.claim.addBankAccount,
  refresh: dispatch.policy.getPolicyDetails,
  addClaim: dispatch.claim.addClaim,
  deleteBank: dispatch.claim.deleteBank,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddClaim);
